/// <amd-module name="VSSUI/ItemIndicator" />
export * from "./Components/ItemIndicator/index";